export enum FunnelSweepFieldAnalysisCategory {
  STAGES = 'stages',
  AUTOMATIONS = 'automations',
  ALERTS = 'alerts',
  ASSIGNMENTS = 'assignments',
}
